import React from 'react';
import PropTypes from 'prop-types';
import { CircleButton as EcoCircleButton } from "@bsw/react-nightingale";
//import { Icon } from "../../index";
//import './circle_button.scss';

export const CircleButton = (props) => {
    const circleButtonAs = props?.as || (props?.href ? 'a' : props?.to ? RouterLink : undefined);

    return <EcoCircleButton
        {...props}
        as={circleButtonAs}
    />;
}

//export const CircleButton = ({
//    as = 'button',
//    colorStyle = 'default',
//    icon = null,
//    name = null,
//    size = 'small',
//    disabled = false,
//    onClick,
//    ...htmlProps
//}) => {
//    const circleButtonClasses = [
//        `bsw-circle-button`,
//        `bsw-circle-button-color--${colorStyle}`,
//        `bsw-circle-button-size--${size}`,
//        `${disabled ? 'bsw-circle-button--disabled' : ''}`
//    ].join(' ');

//    const iconColor = {
//        accent: '$color-primary-a2',
//        default: '$color-primary-a3',
//        float: '$color-primary-a3',
//        inverse: '$color-primary-c1',
//        outline: '$color-primary-c1',
//    };

//    const isButton = as === 'button' ? true : false;
//    const Element = as;

//    return (
//        <Element
//            {...htmlProps}
//            className={circleButtonClasses}
//            onClick={onClick}
//            disabled={isButton ? disabled : false}
//            type={isButton ? htmlProps?.type || "button" : null}
//        >
//            <Icon
//                name={icon ? icon : name}
//                size="medium"
//                color={iconColor[colorStyle]}
//                disabled={disabled}
//            />
//        </Element>
//    )
//}

//CircleButton.propTypes = {
//    as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
//    colorStyle: PropTypes.oneOf(['accent', 'default', 'float', 'inverse', 'outline']),
//    icon: PropTypes.string,
//    size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
//    disabled: PropTypes.bool,
//    onClick: PropTypes.func,
//};